require('./ConfirmStep.scss');

// @vendor
const React = require('react');
const Immutable = require('immutable');
const PropTypes = require('prop-types');

// @core
const { FormattedText, formatText } = require('core/i18n').i18n;

// @utilities
const { getAddress } = require('utilities/personalDataHelper');
const { getFormattedPhone, getPhoneCodeFromOriginCountry, getListCountriesWithAdditionalTaxing } = require('utilities/personalDataHelper');

// @components
const { Accordion } = require('commonsComponents/accordion');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const Highlighted = require('components/commons/highlighted/highlighted');
const TaxAdditionalCountryData = require('components/myProfile/taxAdditionalCountryList/taxAdditionalCountryData');

// @constants
const { PREFIX_SPANISH_ISIN_CODE, PROFILE_EDITOR_UPDATE_OTP_ON_EMAIL } = require('constants/index');
const PROVINCES = require('constants/provinces');
const { getTranslatedCountry } = require('constants/countries');
const { getTranslatedRoad } = require('constants/typeOfRoads');
const { PROFILE_EDITOR_UPDATE } = require('constants/operationTypes');
const {
    PROFILE_EDIT_CONFIG,
    PROFILE_EDIT_FORMS: {
        NEWADDRESS,
        ADDRESS,
        EMAIL,
        FISCAL_DATA,
        PHONE
    }
} = require('constants/myProfileEditor');


class ConfirmStep extends React.Component {
    applyHighlightToObj() {
        const { immProfileEditor } = this.props;
        const immStep = immProfileEditor.getIn(['steps', 0]);
        const { listPaisesTributacionAdicInitial } = immStep.toJS();

        const immCountries = getListCountriesWithAdditionalTaxing(immStep);

        const highlightAppplied = immCountries.toJS().map((pais) => {
            pais.highlight = {}

            if (pais.id >= 0) {
                const initialValues = listPaisesTributacionAdicInitial.find(paisInitial => paisInitial.id === pais.id);
                pais.highlight = {
                    paisTributacion: !initialValues || (pais.paisTributacion.trim() !== initialValues.paisTributacion.trim()),
                    indTipoTributacion: !initialValues || (pais.indTipoTributacion.trim() !== initialValues.indTipoTributacion.trim()),
                    codigodocumpersonacorp: !initialValues || (pais.tin.codigodocumpersonacorp.trim() !== initialValues.tin.codigodocumpersonacorp.trim())
                }
            } else {
                pais.highlight = {
                    indTipoTributacion: true,
                    paisTributacion: true,
                    codigodocumpersonacorp: true
                };
            }
            return pais;
        });
        return Immutable.fromJS(highlightAppplied);
    }

    buildListCountriesWithAdditionalTaxing() {
        const immStep = this.props.immProfileEditor.getIn(['steps', 0]);
        const listCountriesAdditionalTaxing = this.applyHighlightToObj();
        let content;
        if (listCountriesAdditionalTaxing && (immStep.get('moreFiscalResidences') == 'N' || (listCountriesAdditionalTaxing.size === 0 || !listCountriesAdditionalTaxing.getIn([0, 'indTipoTributacion'])))) {
            content = <FormattedText className="ok-informative-list-item__body-text" value="profile-taxInformation_noAdditionalTributation" />;

            if (immStep && immStep.get('listPaisesTributacionAdicInitial') && immStep.get('listPaisesTributacionAdicInitial').size) {
                content = <Highlighted isHighlighted={true}>{content}</Highlighted>;
            }
        } else {
            content = listCountriesAdditionalTaxing.map((item, index) => (
                <div className="ok-informative-list-item__body-text" key={index}>
                    <TaxAdditionalCountryData immCountry={item} />
                </div>
            ));
        }
        return content;
    }

    buildFiscalNumber() {
        const { immProfileEditor, immProfile } = this.props;
        const step = immProfileEditor.getIn(['steps', 0]);

        const content = step.get('residenceCountry') == PREFIX_SPANISH_ISIN_CODE ?
            step.get('nifNie') || immProfile.get('documentoIdentificacion').get('codigodocumpersonacorp') :
            step.get('residenceTin') || step.get('textAreaTin')

        return immProfile && content != immProfile.get('documentoIdentificacion').get('codigodocumpersonacorp') ?
            <Highlighted isHighlighted={true}>{content}</Highlighted> :
            content
    }

    getDataChanged() {
        const { immProfileEditor } = this.props;
        const immStep = immProfileEditor.getIn(['steps', 0]);
        const groupData = [];
        let title = '';

        switch (immProfileEditor.get('editMode')) {
            case NEWADDRESS: {
                const immFormProfileAddressFields = Immutable.fromJS({
                    codigoPostal: immStep.get('postalCode'),
                    nombreDeVia: immStep.get('streetName').toUpperCase(),
                    nombrePlaza: immStep.get('locality').toUpperCase(),
                    numeroDeVia: immStep.get('numberStreet'),
                    paisDomicilio: immStep.get('country'),
                    plaza: {
                        plaza: {
                            provincia: immStep.get('province')
                        }
                    },
                    restoDomicilio: immStep.get('restOfAddress').toUpperCase(),
                    tipoDeVia: immStep.get('typeOfRoads'),
                    residenceCountry: immStep.get('residenceCountry')

                });
                groupData.push({
                    title: 'profile-summaryResidenceCountry',
                    visible: true,
                    value: <Highlighted isHighlighted={true}>{getTranslatedCountry(immStep.get('residenceCountry'))}</Highlighted>
                }, {
                    title: 'profile-summaryFiscalNumber',
                    visible: true,
                    value: this.buildFiscalNumber()
                });
                groupData.push({
                    title: 'profile-contactData_address',
                    visible: true,
                    value: this.formatAddress(immFormProfileAddressFields, immStep)
                }, {
                    title: 'profile-taxInformation_CountriesAdditionalTributationTitle',
                    visible: true,
                    value: this.buildListCountriesWithAdditionalTaxing()
                });
                break;
            }
            case EMAIL:
                groupData.push({
                    title: 'profile-contactData_email',
                    visible: true,
                    value: immStep.get('email')
                });
                groupData.push({
                    title: 'profileEditForm-otp_email_ok',
                    visible: true,
                    value: immStep.get('repeatEmail')
                });
                break;
            case ADDRESS:
                const immFormProfileFields = Immutable.fromJS({
                    codigoPostal: immStep.get('postalCode'),
                    nombreDeVia: immStep.get('streetName').toUpperCase(),
                    nombrePlaza: immStep.get('locality').toUpperCase(),
                    numeroDeVia: immStep.get('numberStreet'),
                    paisDomicilio: immStep.get('addressCountry'),
                    plaza: {
                        plaza: {
                            provincia: immStep.get('province')
                        }
                    },
                    restoDomicilio: immStep.get('restOfAddress').toUpperCase(),
                    tipoDeVia: immStep.get('typeOfRoads')
                });
                groupData.push({
                    title: 'profile-contactData_address',
                    visible: true,
                    value: this.formatAddress(immFormProfileFields, immStep)
                });
                break;
            case FISCAL_DATA:
                const isBirthCountryDirty = this.isDirty(immStep, 'birthCountry');
                const birthCountry = immStep.get('birthCountry');

                const highlightedBirthCountry = this.highlightComponentWrapper(isBirthCountryDirty, getTranslatedCountry(birthCountry));

                const highlightedBirthSquare = this.highlightIfNeeded(immStep, 'birthSquare');

                const isBirthProvinceDirty = this.isDirty(immStep, 'birthProvince');
                const birthProvince = immStep.get('birthProvince').trim();
                let highlightedBirthProvince = '';
                title = 'profile-taxInformation_title';

                if (birthProvince) {
                    highlightedBirthProvince = this.highlightComponentWrapper(isBirthProvinceDirty, PROVINCES[birthProvince]);
                }

                groupData.push({
                    title: 'profile-birthCountry',
                    visible: true,
                    value: highlightedBirthCountry
                },
                    {
                        title: 'profile-taxInformation_birthLocality',
                        visible: true,
                        value: highlightedBirthSquare
                    },
                    {
                        title: 'profile-taxInformation_birthProvince',
                        visible: immStep.get('birthCountry') === PREFIX_SPANISH_ISIN_CODE,
                        value: highlightedBirthProvince
                    }, {
                    title: 'profile-taxInformation_CountriesAdditionalTributationTitle',
                    visible: true,
                    value: this.buildListCountriesWithAdditionalTaxing()
                });
                break;
            case PHONE:
                const { immProfileFields } = this.props;
                const originCountry = immProfileFields.get('originCountry');
                groupData.push({
                    title: 'profile-contactData_new_phone',
                    visible: true,
                    value: getFormattedPhone(getPhoneCodeFromOriginCountry(immProfileFields && immProfileFields.get('originCountry')) + immStep.get('phoneNumber'), originCountry)
                });
                break;
        }

        return <div>{this.buildDataFromGroup(groupData, title)}</div>;
    }

    buildDataFromGroup(dataGroup, title) {
        return (
            <OKInformativeList columns={2} title={title}>
                {
                    dataGroup.map((data, index) => {
                        const element = (
                            <OKInformativeListItem
                                compact
                                key={index}
                                title={formatText(data.title)}
                                onlyChildren
                                editButton={data.editButton}
                            >
                                {data.value}
                            </OKInformativeListItem>
                        );

                        return data.visible ? element : null;
                    })
                }
            </OKInformativeList>
        );
    }

    buildHighlightedModificationsMessage() {
        const message = this.highlightComponentWrapper(true, <FormattedText value="profile-infoMessage02" />);
        return (
            <p className="confirm-step__info-message">
                <FormattedText className="confirm-step__info-message-text" value="profile-infoMessage01" />
                {message}
            </p>
        );
    }

    formatAddress(immProfile, immStep) {
        const {
            locality,
            numberStreet,
            postalCode,
            province,
            restOfAddress,
            streetName,
            typeOfRoads,
            addressCountry
        } = getAddress(immProfile);

        const fields = [
            {
                dirty: this.isDirty(immStep, 'typeOfRoads'),
                value: typeOfRoads ? getTranslatedRoad(typeOfRoads) : ''
            },
            {
                dirty: this.isDirty(immStep, 'streetName'),
                value: streetName ? streetName : ''
            },
            {
                dirty: this.isDirty(immStep, 'numberStreet'),
                value: (numberStreet ? numberStreet : '') + ','
            },
            {
                dirty: this.isDirty(immStep, 'restOfAddress'),
                value: restOfAddress ? restOfAddress : ''
            },
            {
                dirty: this.isDirty(immStep, 'locality'),
                value: (locality ? locality + ',' : '')
            },
            {
                dirty: this.isDirty(immStep, 'province'),
                value: (province ? PROVINCES[province] + ',' : '')
            },
            {
                dirty: this.isDirty(immStep, 'addressCountry'),
                value: addressCountry ? addressCountry : ''
            },
            {
                dirty: this.isDirty(immStep, 'postalCode'),
                value: postalCode ? `(${postalCode})` : ''
            }
        ];

        return (
            <span>
                {
                    fields.map((field, index) => {
                        const space = index ? ' ' : '';
                        return (
                            <span key={index}>
                                {space}
                                {this.highlightComponentWrapper(field.dirty, field.value)}
                            </span>
                        );
                    })
                }
            </span>
        );
    }

    highlightComponentWrapper(status, value) {
        return <Highlighted isHighlighted={status}>{value}</Highlighted>;
    }

    highlightIfNeeded(immStep, field) {
        const isFieldDirty = this.isDirty(immStep, field);
        return this.highlightComponentWrapper(isFieldDirty, immStep.get(field));
    }

    isDirty(immStep, field) {
        let isDirty = false;
        if (immStep.get(field) && immStep.get(`${field}Initial`) !== undefined) {
            isDirty = immStep.get(field).trim() !== immStep.get(`${field}Initial`).trim();
        }
        return isDirty;
    }

    render() {
        const { immProfileEditor, taggingOnKeyPress } = this.props;
        const editMode = immProfileEditor.get('editMode');
        const { highlighted, titleTranslation } = PROFILE_EDIT_CONFIG[editMode].confirmStep;
        const changedData = this.getDataChanged();
        const immStep = immProfileEditor.getIn(['steps', 0]);
        const otpBySmsOrEmail = immStep.get('otpBySmsOrEmail');
        let highlightedModificationsMessage;
        let operationTypeForSignaturePattern;
        let delayedMessageForMailOrSMS;
        let confirmationCodeSubtitle;

        if (highlighted) {
            highlightedModificationsMessage = this.buildHighlightedModificationsMessage();
        } else if ([PHONE, EMAIL].includes(editMode)) {
            highlightedModificationsMessage = (
                <p className="confirm-step__info-message">
                    <FormattedText value={PROFILE_EDIT_CONFIG[editMode].editFormStep.highlightedModificationsMessage} />
                </p>
            );
        }

        if (editMode === PHONE) {
            operationTypeForSignaturePattern = otpBySmsOrEmail
        }
        else {
            operationTypeForSignaturePattern = PROFILE_EDITOR_UPDATE
        }

        if (operationTypeForSignaturePattern === PROFILE_EDITOR_UPDATE_OTP_ON_EMAIL) {
            delayedMessageForMailOrSMS = 'signaturePattern-delayedMail1';
            confirmationCodeSubtitle = 'cardPinRequest-confirmationCodeSubtitleForMail';
        }

        return (
            <div className="confirm-step">
                <h4 className="confirm-step__header">
                    <FormattedText value={`profileEditConfirm-${titleTranslation}`} />
                </h4>
                <Accordion id="confirm-step-accordion" customClassName="confirm-step__accordion" isExpanded={true}>
                    <AccordionHeader name="AccordionHeader" canBeExpanded={false}>
                        {highlightedModificationsMessage}
                    </AccordionHeader>
                    <AccordionBody name="AccordionBody">{changedData}</AccordionBody>
                </Accordion>
                <div className="confirm-step__wrapper-signature-pattern">
                    <SignaturePattern
                        operationType={operationTypeForSignaturePattern}
                        operationParams={{}}
                        delayedMessageForMailOrSMS={delayedMessageForMailOrSMS}
                        confirmationCodeSubtitle={confirmationCodeSubtitle}
                        taggingOnKeyPress={taggingOnKeyPress}
                    />
                </div>
            </div>
        );
    }
}

ConfirmStep.defaultProps = {
    taggingOnKeyPress: () => { }
}
ConfirmStep.propTypes = {
    immProfile: PropTypes.object,
    immProfileEditor: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    taggingOnKeyPress: PropTypes.func,
};

module.exports = ConfirmStep;